import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import PersonAdd from '@mui/icons-material/PersonAdd'
import Settings from '@mui/icons-material/Settings'
import Logout from '@mui/icons-material/Logout'
import { useEffect } from 'react'
import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { LogoutAction } from '../../Store/Actions/AuthActions'
import BackDropCmp from '../BackDrop/BackDrop'
import { Stack } from '@mui/material'
import NoImageFound from '../../Assets/Images/no_image.png'
import ProfileAvatar from '../Profile/ProfileAvatar'
export default function AvatarCmp({ img, firstLetter, profileLink, profileDetails }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    // const [profilePic, setProfilePic] = useState()
    // const user = JSON.parse(localStorage.getItem('userData'))

    // const navigate = useNavigate()
    // const dispatch = useDispatch()

    // const logoutHandler = () => {
    //     dispatch(LogoutAction(navigate))
    // }
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                }}
            >
                <Tooltip title="Account settings">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <ProfileAvatar style={{ width: 32, height: 32 }} src={img || NoImageFound}>
                            {/* {firstLetter?.slice(0, 1).toUpperCase()} */}
                        </ProfileAvatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                sx={{
                    ul: {
                        width: '260px',
                    },
                }}
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                    {img && <ProfileAvatar style={{ width: 32, height: 32 , marginRight:'10px'}} src={img || NoImageFound} >
                        {/* {!img && (firstLetter?.slice(0, 1).toUpperCase() || 'U')} */}
                    </ProfileAvatar>}
                    {!img && <Avatar />}
                    <Stack>
                        <Typography variant="subtitle1" fontWeight="bold">
                            {profileDetails?.first_name + " " + profileDetails?.last_name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {profileDetails?.type || 'user@example.com'}
                        </Typography>
                    </Stack>
                </Box>
                <Divider />
                <NavLink to={profileLink ? profileLink : '/profile'}>
                    <MenuItem>
                        {/* <Avatar /> */}
                       My Profile
                    </MenuItem>
                </NavLink>
                {/* <MenuItem>
          <Avatar /> My account
        </MenuItem> */}
                {/* <Divider /> */}
                {/* <MenuItem>
          <ListItemIcon>
            <PersonAdd fontSize="small" />
          </ListItemIcon>
          Add another account
        </MenuItem> */}
                {/* <MenuItem>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}
                {/* <MenuItem onClick={logoutHandler}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem> */}
            </Menu>
        </>
    )
}
